module.exports = __webpack_public_path__ + "assets/icons/private-home.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/building/private-home.png
// module id = ./src/styles/icons/building/private-home.png
// module chunks = 0